import * as yup from 'yup';
import { requiredErrorMessage, requiredNameSchema } from '@common/schema';

export const addFolderSchema = yup.object().shape({
  name: requiredNameSchema,
  organization_id: yup.string().required(requiredErrorMessage),
  isPrivate: yup.boolean().required(requiredErrorMessage),
});
